export interface IUserListSelectorDialogCondition {
  name: string;
  departmentId: string;
  defaultSelectedProfessionCodes: string[];
  shouldHideSelectLoginUserButton?: boolean;
  shouldHideClearSelectionButton?: boolean;
}

export function instanceOfIUserListSelectorDialogCondition(instance: any): instance is IUserListSelectorDialogCondition {
  return instance
    && (instance.name !== undefined)
    && (instance.departmentId !== undefined)
    && (instance.defaultSelectedProfessionCodes !== undefined);
}
